import React from 'react'
import { IconWarning20 } from '@lightspeed/unified-components-helios-theme/react'

interface InputErrorProps {
  errorElement: React.JSX.Element
  showIcon?: boolean
}

// Wrapper component for displaying error messages related to line item input fields
export const InputErrorMessage: React.FC<InputErrorProps> = props => {
  return (
    <div className="uc-base">
      <div className="flex items-center gap-2 text-no-default typography-body-xs mt-1">
        {props.showIcon && (
          <IconWarning20
            aria-hidden="true"
            className="shrink-0"
            data-cy="fa-exclamation-triangle"
          />
        )}
        <div>{props.errorElement}</div>
      </div>
    </div>
  )
}
